/**
 * Návrat na původní stránku po přihlášení (odkazy z e-mailů, z Pohody apod. vedou rovnou na detail).
 * Cesta se předává v `?next=` — funguje pro <Navigate> i pro tvrdé přesměrování `window.location`.
 */

/** Adresa přihlášení s návratem na danou cestu (bez návratu na samotné /login). */
export function loginPath(path: string): string {
  if (!path || path === '/' || path.startsWith('/login')) return '/login'
  return `/login?next=${encodeURIComponent(path)}`
}

/** Bezpečná cesta z `?next=` — jen interní cesta aplikace, nikdy jiný web. */
export function safeNext(next: string | null): string | null {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\') || next.startsWith('/login')) return null
  return next
}
